module.exports = __webpack_public_path__ + "img/msgotg.2bec9ae0.svg";